import React from 'react';
import { NumericFormat, NumberFormatValues } from 'react-number-format';

interface InputMoedaProps {
  label: string;
  value: number;
  onChange: (val: number) => void;
  disabled?: boolean;
  placeholder?: string;
  style?: React.CSSProperties;
}

export const InputMoeda: React.FC<InputMoedaProps> = ({
  label,
  value,
  onChange,
  disabled = false,
  placeholder,
  style = {},
}) => {
  return (
    <label style={{ display: 'block', width: '100%' }}>
      {label}
      <NumericFormat
        value={value}
        onValueChange={(values: NumberFormatValues) => {
          const numero = values.floatValue !== undefined ? values.floatValue : 0;
          onChange(numero);
        }}
        thousandSeparator="."
        decimalSeparator=","
        fixedDecimalScale
        decimalScale={2}
        disabled={disabled}
        placeholder={placeholder}
        inputMode="decimal"
        style={{
          width: '100%',
          background: '#f9f9f9',
          fontSize: 'max(1vw, 10px)',
          padding: '1vh 2vw',
          borderRadius: '0.25rem',
          border: '1px solid #ccc',
          marginTop: '0.3rem',
          ...style,
        }}
      />
    </label>
  );
};
